import {
  Flex,
  Box,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  HStack,
  InputRightElement,
  Stack,
  Button,
  Heading,
  Text,
  useColorModeValue,
  Link,
} from '@chakra-ui/react';
import { useState } from 'react';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';

import LogoIcon from '../components/customIcons/LogoIcon'
import FormBackgroundImage from '../assets/images/Form-Background-Image.jpg';

export default function Join() {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="login-page page">
      <Flex
        minH={'100vh'}
        align={'center'}
        justify={'center'}
        className={'fade-in-1'}
        >
        <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
          <Stack align={'center'}>
            <Heading fontSize={'4xl'} textAlign={'center'} color={'brand.black'}>
              Sign up to become an ally today
            </Heading>
            <Text fontSize={'lg'} color={'gray.600'}>
              and be the change you want to see
            </Text>
          </Stack>
          <Box
            rounded={'lg'}
            bg={useColorModeValue('white', 'gray.700')}
            boxShadow={'lg'}
            p={8}>
            <Stack spacing={4}>
              <HStack>
                <Box>
                  <FormControl id="firstName" isRequired>
                    <FormLabel>First Name</FormLabel>
                    <Input type="text" />
                  </FormControl>
                </Box>
                <Box>
                  <FormControl id="lastName">
                    <FormLabel>Last Name</FormLabel>
                    <Input type="text" />
                  </FormControl>
                </Box>
              </HStack>
              <FormControl id="email" isRequired>
                <FormLabel>Email address</FormLabel>
                <Input type="email" />
              </FormControl>
              <FormControl id="password" isRequired>
                <FormLabel>Password</FormLabel>
                <InputGroup>
                  <Input type={showPassword ? 'text' : 'password'} />
                  <InputRightElement h={'full'}>
                    <Button
                      variant={'ghost'}
                      onClick={() =>
                        setShowPassword((showPassword) => !showPassword)
                      }>
                      {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                    </Button>
                  </InputRightElement>
                </InputGroup>
              </FormControl>
              <Stack spacing={10} pt={2}>
                <Button
                  loadingText="Submitting"
                  as={'a'}
                  href={'/'}
                  size="lg"
                  bg={'brand.main'}
                  color={'white'}
                  rightIcon={<LogoIcon />}
                  _hover={{
                    bg: 'brand.dark',
                  }}
                  >
                  Sign up
                </Button>
              </Stack>
              <Stack pt={6}>
                <Text align={'center'}>
                  Already a user? <Link color={'brand.main'} href="/login">Login</Link>
                </Text>
              </Stack>
            </Stack>
          </Box>
        </Stack>
        <img
          className={'background-image low-opacity'}
          src={FormBackgroundImage}
          alt='Diverse team working hard'
        />
      </Flex>
    </div>
  );
}
